import {
  server_ws_transcribe_url,
  close_ws_message_to_server,
  server_transcribe_url,
  speaker_tasks_diarization,
  logout_url,
  token,
} from "./api";

const constant = {
  API: {
    SERVER_WEBSOCKET_TRANSCRIBE_URl: server_ws_transcribe_url,
    CLOSE_WS_MESSAGE_TO_SERVER: close_ws_message_to_server,
    SERVER_TRANSCRIBE_URl: server_transcribe_url,
    SPEAKER_TASK: speaker_tasks_diarization,
    LOGOUT_URL: logout_url,
    TOKEN_KEY: token,
  },
  COLOR: {
    BACK_COLOR_OF_CIRCLE_HAS_ICON: {
      DEFAULT: "#8F8F8F",
      ACTIVE_MIC: "#00B3A1",
      ACTIVE_ATTACH: "#118AD3",
      ACTIVE_SMALL_LINK: "#FF1654",
      ERROR: "#303030",
    },
  },
  ICON_NAMES: {
    LINK: "small_link_icon",
    ATTACH: "small_cloud_icon",
    MIC: "small_mic_icon",
    RESTART: "restart_icon",
  },
  URL_REGEX: '^((ftp|http)s?://)?(www.)?[^ "]{2,256}\\.\\w{2,6}[^ "]*$', // eslint-disable-line
};

export default constant;
